import BaseError from './BaseError';

class XhrError extends BaseError {
  url?: string;
  constructor(message: string, fileName?: string, lineNumber?: number) {
    super('XhrError', message, fileName, lineNumber);
  }
}

export default XhrError;
